<h2 mat-dialog-title>Edit VRChat Account</h2>
<mat-dialog-content>
    @if (data && data.connections.vrchat) {
        <div style="display: flex; gap: 10px; flex-direction: column;">
            <mat-form-field>
                <mat-label>VRChat ID</mat-label>
                <input matInput [(ngModel)]="data.connections.vrchat.id" />
            </mat-form-field>

            <mat-form-field>
                <mat-label>VRChat Username</mat-label>
                <input matInput [(ngModel)]="data.connections.vrchat.username" />
            </mat-form-field>

            @if (data.connections.vrchat.avatar) {
                <mat-form-field>
                    <mat-label>VRChat Avatar URL</mat-label>
                    <input matInput [(ngModel)]="data.connections.vrchat.avatar" />
                </mat-form-field>
            }
        </div>
    } @else {
        Something went wrong
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-button (click)="save()">Save</button>
</mat-dialog-actions>
